import { render, staticRenderFns } from "./orders-header.vue?vue&type=template&id=27161d14"
import script from "./orders-header.vue?vue&type=script&lang=js"
export * from "./orders-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports